import { render, staticRenderFns } from "./productType.vue?vue&type=template&id=a4f35b64&scoped=true"
import script from "./productType.vue?vue&type=script&lang=js"
export * from "./productType.vue?vue&type=script&lang=js"
import style0 from "./productType.vue?vue&type=style&index=0&id=a4f35b64&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4f35b64",
  null
  
)

export default component.exports